import ToolsFillIcon from "remixicon-react/ToolsFillIcon";
import EyeLineIcon from "remixicon-react/EyeLineIcon";
import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Addicon from "@mui/icons-material/Add";
import { useAppDispatch } from "$store";
import { EditableInfoContainer } from "$components/InfoContainer/EditableInfoContainer";
import { useStyles } from "./CompanyProfile.styles";
import { CompanyType } from "$types";
import { Button } from "$components";
import { removeFilter } from "$actions/app";

export const MaterialBlock = memo(function MaterialBlock({
  company,
  isDisabled,
  tab,
  clientsWithCatalogue,
}: any) {
  const classes = useStyles();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const handleClick = (url) => {
    dispatch(removeFilter());
    navigate(url);
  };
  const cType = company?.companyTypes.filter((t) => t === tab);

  const makeButton = useCallback(
    (type, company, withSecondary) => {
      let link = "";
      let displayText;
      let icon;
      let disableLink = false;
      switch (type) {
        case CompanyType.CLIENT:
          link = `/entreprise/${company?._id}/catalogue`;
          displayText = withSecondary
            ? "Voir le catalogue"
            : "Créer le catalogue";

          icon = withSecondary ? <EyeLineIcon /> : <Addicon />;

          break;
        case CompanyType.CONTRIBUTOR:
          link = `/entreprise/catalogue?contributor=${company?._id}`;
          icon = <EyeLineIcon />;
          displayText = "Voir le(s) catalogue(s)";
          disableLink = clientsWithCatalogue?.length === 0;

          break;
        default:
          if (cType.includes(CompanyType.CLIENT)) {
            link = `/entreprise/${company?._id}/stock`;
          }
          if (cType.includes(CompanyType.CONTRIBUTOR)) {
            link = `/stock?contributor=${company?._id}`;
          }
          icon = <EyeLineIcon />;
          displayText = "Voir stock";

          break;
      }

      return (
        <Button
          color={withSecondary ? "secondary" : "primary"}
          onClick={() => handleClick(link)}
          disabled={disableLink || isDisabled}
        >
          {icon}
          {displayText}
        </Button>
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [clientsWithCatalogue, isDisabled]
  );

  const data = [
    ...(cType.includes(CompanyType.CLIENT)
      ? [
          {
            label: "Catalogue",
            value: makeButton(
              CompanyType.CLIENT,
              company,
              Boolean(company?.products?.length)
            ),
            className: "right",
          },
        ]
      : []),
    ...(cType.includes(CompanyType.CONTRIBUTOR)
      ? [
          {
            label: "Catalogue",
            value: makeButton(CompanyType.CONTRIBUTOR, company, true),
            className: "right",
          },
        ]
      : []),
    {
      label: "Stock",
      value: makeButton("STOCK", company, true),
      className: "right",
    },
  ];

  return (
    <EditableInfoContainer
      title="Matériel"
      icon={<ToolsFillIcon />}
      data={data}
      className={[classes.materialBlock]}
    />
  );
});
